import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 82vh;
  padding: 10px 10px 10px 0px;
  // width: 424px;
  width: ${(props) => props.width || "424px"};
  margin-left:2.5%
`;

export const MediaContainer = styled.div`
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
  margin-left:5px;

  height: calc(82vh - <header-height>);
`;
